import { useQueryWithStore } from 'react-admin'
import { useSelector } from 'react-redux'
import moment from 'moment'

const useVisitorsInBuilding = () => {
  const { propertyId } = useSelector(state => state.property)
  const { loaded: enterEventsLoaded, total: enterEventsTotal, data: enterEventsData } = useQueryWithStore({
    type: 'getList',
    resource: 'enterEvents',
    payload: {
      filter: {
        propertyId,
        left: false
      },
      pagination: { page: 1, perPage: 10000 },
      sort: { field: 'date', order: 'DESC' }
    }
  })
  const { loaded: deliveryEventsLoaded, total: deliveryEventsTotal, data: deliveryEventsData } = useQueryWithStore({
    type: 'getList',
    resource: 'deliveryEvents',
    payload: {
      filter: {
        propertyId,
        left: false
      },
      pagination: { page: 1, perPage: 10000 },
      sort: { field: 'date', order: 'DESC' }
    }
  })
  const { loaded: accessCardEventsLoaded, total: accessCardEventsTotal, data: accessCardEventsData } = useQueryWithStore({
    type: 'getList',
    resource: 'accessCardEvents',
    payload: {
      filter: {
        propertyId,
        left: false
      },
      pagination: { page: 1, perPage: 10000 },
      sort: { field: 'date', order: 'DESC' }
    }
  })
  const { loaded: internalAccessCardEventsLoaded, total: internalAccessCardEventsTotal, data: internalAccessCardEventsData } = useQueryWithStore({
    type: 'getList',
    resource: 'internalAccessCardEvents',
    payload: {
      filter: {
        propertyId,
        left: false
      },
      pagination: { page: 1, perPage: 10000 },
      sort: { field: 'date', order: 'DESC' }
    }
  })

  return {
    loaded: deliveryEventsLoaded && enterEventsLoaded && accessCardEventsLoaded && internalAccessCardEventsLoaded,
    total: deliveryEventsTotal + enterEventsTotal + internalAccessCardEventsTotal,
    totalWithAccessCardEvents: deliveryEventsTotal + enterEventsTotal + internalAccessCardEventsTotal + accessCardEventsTotal,
    eventsData: [...deliveryEventsData || [], ...enterEventsData || [], ...internalAccessCardEventsData || []].sort((a, b) => {
      return moment(b.date).local() - moment(a.date).local()
    }),
    allEventsData: [...deliveryEventsData || [], ...enterEventsData || [], ...internalAccessCardEventsData || [], ...accessCardEventsData || []].sort((a, b) => {
      return moment(b.date).local() - moment(a.date).local()
    })
  }
}

export default useVisitorsInBuilding
